// Simple mobile device/tablet detection
const isIos =
  navigator.userAgent.match(/iphone|ipad|ipod/i) ||
  (navigator.userAgent.indexOf("Mac") !== -1 && "ontouchend" in document);
const isMobile =
  !!(
    typeof navigator !== "undefined" &&
    (isIos || navigator.userAgent.match(/android/i))
  ) || new URL(location.href).searchParams.get("mobile") === "true";

// Mixin that adds an `isMobile` data variable
export const IsMobile = {
  data() {
    return {
      isIos,
      isMobile
    };
  }
};
